import { Injectable } from "@angular/core";
import { ShareMessageRepo } from "@app/core/share-message/domain/share-message.repo";
import { ShareMessageMobileWeb } from "@app/core/share-message/infrastructure/mobile-web/share-message.mobile-web";

import { Observable } from "rxjs";

@Injectable()
export class ShareMessageMobileWebImplRepo implements ShareMessageRepo {
  constructor(private shareMessageMobileWeb: ShareMessageMobileWeb) {}

  shareMessage(message: string, url: string): Observable<string> {
    return this.shareMessageMobileWeb.execute(message, url);
  }
}
